import React from "react";
import LargeImageListItem from "./LargeImageListItem";
/**
 *
 * @typedef {Object} state
 * @prop {number} idx -
 * @prop {"description" | "title"} field
 */

const LargeImageListView = ({ images = [], isLocked, onPropUpdate, removeImage }) => {
  const _onPropUpdate = (propInfo) => {
    onPropUpdate && onPropUpdate(propInfo);
  };

  const _removeImage = (idx) => {
    removeImage && removeImage(idx);
  };

  return (
    <div data-testid="large-image-list-view">
      {images.map((img, idx) => (
        <LargeImageListItem
          disabled={isLocked}
          key={`image-${idx}`}
          removeImage={_removeImage}
          image={img}
          index={idx}
          onPropUpdate={_onPropUpdate}
        />
      ))}
    </div>
  );
};

export default LargeImageListView;
